import { Scaffold } from "@Light/scaffold";
import { createContext, useContext } from "react";
import {
  SetURLSearchParams,
  To,
  useNavigate as useNavigateOriginal,
  useSearchParams as useSearchParamsOriginal,
  useParams as useParamsOriginal,
} from "react-router-dom";
import { useScaffold as useScaffoldOriginal } from "@Light/scaffold";
import { useDispatch as useDispatchOriginal } from "react-redux";

export type MockContextState = {
  scaffold?: Scaffold;
  navigate?: (path: To) => void;
  searchParams?: [URLSearchParams, SetURLSearchParams];
  params?: Record<string, string>;
  dispatch?: (action: any) => void;
};

export const MockContext = createContext<MockContextState | undefined>(
  undefined,
);

export function useScaffold() {
  const mock = useContext(MockContext);
  const original = useScaffoldOriginal();
  return mock?.scaffold ?? original;
}

export function useNavigate() {
  const mock = useContext(MockContext);
  const original = useNavigateOriginal();
  return mock?.navigate ?? original;
}

export function useSearchParams() {
  const mock = useContext(MockContext);
  const original = useSearchParamsOriginal();
  return mock?.searchParams ?? original;
}

export function useParams() {
  const mock = useContext(MockContext);
  const original = useParamsOriginal();
  return mock?.params ?? original;
}

export function useDispatch() {
  const mock = useContext(MockContext);
  const original = useDispatchOriginal();
  return mock?.dispatch ?? original;
}
